import {saveAs} from 'file-saver';
import { DownloadBookingDocumentsQueryResult } from '../apis/dtos';

export const downloadFile = (content: DownloadBookingDocumentsQueryResult) => {
  const blob = createBlob(content.content, content.mimeType ?? "application/octet-stream");
  saveAs(blob, content.fileName);
}

export const previewFile = (content: unknown, fileType: string) => {
  const blob = createBlob(content, fileType);
  const url = URL.createObjectURL(blob);

  const newWindow = window.open('', '_blank');
  if (newWindow) {
    newWindow.location = url;
  }
}

const createBlob = (content: unknown, fileType: string) => {
  const byteCharacters = atob(content as string);
  const byteNumbers = [byteCharacters.length];
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: fileType });
}